import React from 'react';
import ExperienceLanding from '../components/experience-landing/ExperienceLanding';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer'

function Experience() {
    return (
        <div>
            <ExperienceLanding/>
            <Footer/>
        </div>
    )
}

export default Experience
